import { SellerFiscalDataUi } from '@/components/Seller/SellerProfile/FiscalData/SellerFiscalDataUi';
import { UpdateSellerFiscalDataRequest } from '@/data/api/model/sellers/SellersDto';

export const sellerFiscalDataUiToUpdateSellerFiscalDataRequest = (
  input: SellerFiscalDataUi
): UpdateSellerFiscalDataRequest => ({
  legal_name: input.legalName,
  tax_id: input.rfc,
  cfdi_use_id: input.cfdiUse,
  tax_regime_id: input.fiscalRegime,
  email: input.taxEmail,
  zip_code: input.postalCode,
});
